module.exports = __webpack_public_path__ + "static/media/4.8c4c93ec.jpg";